import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { downloadFile } from '@/utils/helper';
import { $file, $http } from '@/axios';
import store from '@/store';

// 查询物品的供应商列表
export const queryModelSuppliers: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMatSuppliers', { ...state.list, loading: true });
    // const res = await $http.post('/model/type/item/supplier/code/list', payload);
    const res = await $http.post('/v1/data/system/org/listbyasset', { ...payload, backType: 'Model' });
    commit('setMatSuppliers', { data: res });
  } catch (e) {
    commit('setMatSuppliers', { data: [] });
  }
};

// 查询材料的供应商列表
export const queryMaterialSuppliers: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMatSuppliers', { ...state.list, loading: true });
    // const res = await $http.post('/material/type/item/supplier/code/list', payload);
    const res = await $http.post('/v1/data/system/org/listbyasset', { ...payload, backType: 'Material' });
    commit('setMatSuppliers', { data: res });
  } catch (e) {
    commit('setMatSuppliers', { data: [] });
  }
};

// 查询某物品品牌的可访问组织列表
export const queryModelOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMatOrgs', { ...state.orgs, loading: true });
    // const {
    //   list, pageSize, pageNum, total,
    // } = await $http.post('/model/supplier/organization/list', { ...payload, backType: 'Model' });
    const {
      list, pageSize, pageNum, total,
    } = await $http.post('/v1/data/system/org/listbyauthedbrand', { ...payload, backType: 'Model' });
    commit('setMatOrgs', { data: list, pageSize, pageNum, total });
  } catch (e) {
    commit('setMatOrgs', { data: [], pageSize: 0, pageNum: 0, total: 0 });
  }
};

// 查询某材料品牌的可访问组织列表
export const queryMaterialOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMatOrgs', { ...state.orgs, loading: true });
    // const {
    //   list, pageSize, pageNum, total,
    // } = await $http.post('/material/supplier/organization/list', payload);
    const {
      list, pageSize, pageNum, total,
    } = await $http.post('/v1/data/system/org/listbyauthedbrand', { ...payload, backType: 'Material' });
    commit('setMatOrgs', { data: list, pageSize, pageNum, total });
  } catch (e) {
    commit('setMatOrgs', { data: [], pageSize: 0, pageNum: 0, total: 0 });
  }
};

// 查询已保存的企业列表(灯具)
export const queryLuminorOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSavedOrgs', { ...state.savedOrgs, loading: true });
    // const res = await $http.get(`/model/type/item/${payload}/supplier/list`);
    const params = { itemId: payload, backType: 'Model' };
    const res = await $http.post('/v1/data/system/org/listbyassetsaved', params);
    commit('setSavedOrgs', { data: res });
  } catch (e) {
    commit('setSavedOrgs', { data: [], selected: '' });
  }
};

// 查询已保存的企业列表(非单一材料)
export const queryUnPrimeOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSavedOrgs', { ...state.savedOrgs, loading: true });
    // const res = await $http.get(`/material/type/item/${payload}/supplier/list`);
    const params = { itemId: payload, backType: 'Material' };
    const res = await $http.post('/v1/data/system/org/listbyassetsaved', params);
    commit('setSavedOrgs', { data: res });
  } catch (e) {
    commit('setSavedOrgs', { data: [], selected: '' });
  }
};

// 新增物品供应商
export const addModelSupplier: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, visible: true, loading: true });
    // await $http.post('/model/type/item/supplier/code/add', payload);
    await $http.post('/v1/asset/item/addsuppliercode', payload);
    store.commit('common/setToast', { visible: true, text: '新增供应商成功' });
  } finally {
    commit('setDialog', { visible: true });
  }
};

// 新增材料供应商
export const addMaterialSupplier: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, visible: true, loading: true });
    // await $http.post('/material/type/item/supplier/code/add', payload);
    await $http.post('/v1/asset/material/addsuppliercode', payload);
    store.commit('common/setToast', { visible: true, text: '新增供应商成功' });
  } finally {
    commit('setDialog', { visible: true });
  }
};

// 编辑物品供应商
export const editModelSupplier: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, visible: true, loading: true });
    // await $http.post('/model/type/item/supplier/code/modify', payload);
    await $http.post('/v1/asset/item/modifysuppliercode', payload);
    store.commit('common/setToast', { visible: true, text: '编辑供应商成功' });
  } finally {
    commit('setDialog', { visible: true });
  }
};

// 编辑材料供应商
export const editMaterialSupplier: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, visible: true, loading: true });
    // await $http.post('/material/type/item/supplier/code/modify', payload);
    await $http.post('/v1/asset/material/modifysuppliercode', payload);
    store.commit('common/setToast', { visible: true, text: '编辑供应商成功' });
  } finally {
    commit('setDialog', { visible: true });
  }
};

// 删除物品供应商
export const deleteModelSupplier: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, visible: true, loading: true });
    // await $http.post('/model/type/item/supplier/code/delete', payload);
    await $http.post('/v1/asset/item/deletesuppliercode', payload);
  } finally {
    commit('setConfirm', { visible: true });
  }
};

// 删除材料供应商
export const deleteMaterialSupplier: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, visible: true, loading: true });
    // await $http.post('/material/type/item/supplier/code/delete', payload);
    await $http.post('/v1/asset/material/deletesuppliercode', payload);
  } finally {
    commit('setConfirm', { visible: true });
  }
};

// 设置默认物品供应商
export const defaultModelSupplier: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, visible: true, loading: true });
    // await $http.post('/model/type/item/supplier/default/set', payload);
    await $http.post('/v1/asset/item/setdefaultsuppliercode', payload);
  } finally {
    commit('setConfirm', { visible: true });
  }
};

// 设置默认材料供应商
export const defaultMaterialSupplier: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, visible: true, loading: true });
    // await $http.post('/material/type/item/supplier/default/set', payload);
    await $http.post('/v1/asset/material/setdefaultsuppliercode', payload);
  } finally {
    commit('setConfirm', { visible: true });
  }
};
